import Button from './Button';
import ButtonGroup from './ButtonGroup';

Button.Group = ButtonGroup;

export { ButtonTheme, ButtonSize, ButtonShape, ButtonType, ButtonProps, ButtonGroupProps } from './PropsType';
export default Button;
